import { routes as routesConnectors } from "@Integrations/Connectors/routes"
import { routes as routesDatasets } from "@Integrations/Datasets/routes"
import { routes as routesPipelines } from "@Integrations/Pipelines/routes"
import { routes as routesRuns } from "@Integrations/Runs/routes"

export const routes = [
    ...routesConnectors,
    ...routesDatasets,
    ...routesPipelines,
    ...routesRuns
]
